export default "__VITE_ASSET__DNFPB94l__"